<template>
	<header class="app-header" :class="{scrolling: scrolled}">
		<v-layout class="app-header-mobile" justify-space-between>
			<div>
				<button class="mr-3" @click="openMenuMobile">
					<img src="static/images/icons/menu.svg" alt="menu" height="20">
				</button>
				<!-- <img 
					src="/static/images/icons/favicon-casamarket.svg" 
					alt="image"
					height="36"> -->
			</div>
			<div>
				<a class="btn-orange" href="#plans">NUESTROS PLANES</a>
			</div>
		</v-layout>
		<ul class="layout app-header-menu align-center" :class="{ 'open-menu' : true}">
			<li class="flex app-header-menu-item app-header-menu-item-logo">
				<router-link
					class="app-header-menu-item-link li-logo"
					to="/"
				>
					<img
						src="/static/images/logos/logo-casa-market-orange.svg"
						alt="logo mi bodega"
						class="image-logo-header"
						height="50px"
						:class="{ 'show-image': !scrolled, 'show-not-image': scrolled }"
					/>
					<img
						src="/static/images/icons/favicon-casamarket.svg"
						alt="logo mi bodega"
						class="image-logo-header"
						height="50px"
						:class="{ 'show-not-image' :scrolled, 'show-not-image': !scrolled }"
					/>
				</router-link>
				<div v-if="!scrolled">
					<p class="mb-0 text-logo">Tu app de pedidos para acercar de <br/> manera segura a comercios y clientes</p>
				</div>
			</li>
			<ul class="link-text-container app-header-menu-item" :class="{ 'open-menu' : openMobile }">
				<li class="logo-close">
					<button @click="closeMenuMobile">
						<img src="/static/images/logos/close.svg" alt="cerrar">
					</button>
				</li>
				<li class="logo-menu-mobile">
					<img src="/static/images/logos/casa-market-white.svg" alt="logo">
				</li>
				<scrollactive class="layout wrap justify-space-between" :offset="50">
					<a
						v-for="item in menu"
						:key="item.id"
						class="app-header-menu-item-link scrollactive-item"
						:href="item.href"
						@click="closeMenuMobile"
					>
						{{ item.title }}
					</a>
				</scrollactive>
			</ul>
		</ul>
	</header>
</template>

<script>

function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	this.scrolled = window.scrollY > 30;
}

function openMenuMobile() {
	this.openMobile = true;
}

function closeMenuMobile() {
	this.openMobile = false;
}


function data() {
	return {
		menu: [
			{
				id: 1,
				href: '#about',
				title: 'CasaMarket',
			},
			{
				id: 2,
				href: '#stepbystep',
				title: 'Cómo Funciona',
			},
			{
				id: 4,
				href: '#features',
				title: 'Beneficios',
			},
			{
				id: 7,
				title: 'Nuestros Planes',
				href: '#plans',
			},
			{
				id: 8,
				href: '#section-banner',
				title: 'Preguntas Frecuentes',
			},
		],
		scrolled: false,
		openMobile: false,
	};
}

export default {
	name: 'app-header',
	data,
	created,
	destroyed,
	methods: {
		handleScroll,
		openMenuMobile,
		closeMenuMobile,
	},
	props: {
		link: [String],
	},
};
</script>

<style lang="scss" scoped>
	.app-header {
		left: 0px;
		padding: 69px 0px 10px 0;
		position: relative;
		right: 0px;
		transition: all 0.5s ease;
		top: 0px;
		width: 100%;
		z-index: 200;

		@media (min-width: 1024px) {
			padding: 44px 4% 44px;
			position: fixed;
		}

		@media (min-width: 1090px) {
			padding: 44px 4% 44px;
		}

		&-btn {
			@media (min-width: 1024px) {
				border-radius: 8px;
				font-size: size(small);
				font-weight: weight(w900);
				height: 42px !important;
				text-transform: uppercase !important;
				width: 100% !important;
			}

			@media (min-width: 1090px) {
				font-size: size(small13);
			}

			@media (min-width: 1190px) {
				font-size: size(medium);
			}
		}

		&.scrolling {
			@media (min-width: 1024px) {
				background: color(white);
				box-shadow: -1px 1px 4px 4px rgba(249,249,249,1);
				-webkit-box-shadow: -1px 1px 4px 4px rgba(249,249,249,1);
				-moz-box-shadow: -1px 1px 4px 4px rgba(249,249,249,1);
				padding: 30px 4%;
			}
		}

		.text-decoration-none {
			text-decoration: none;
		}

		.image-logo-header {
			height: 33px;

			@media (min-width: 1024px) {
				height: 30px;
			}

			@media (min-width: 1090px) {
				height: 31.5px;
			}

			@media (min-width: 1190px) {
				height: 33px;
			}
		}

		&-menu {
			@media (min-width: 1024px) {
				font-size: size(small);
				font-weight: weight(w700);
				list-style: none;
				text-transform: uppercase;
			}

			@media (min-width: 1090px) {
				font-size: size(small13);
			}

			@media (min-width: 1190px) {
				font-size: size(medium);
			}

			&-item {
				&:not(.app-header-menu-item-logo) {
					background: color(primary);
					transition: all 0.5s ease;
					position: fixed;
					height: 100vh;
					left: -100%;
    			top: 0;
					width: 90% !important;

					@media (min-width: 1024px) {
						background: none;
						display: initial;
						position: relative;
						height: auto;
						left: auto;
						width: 56% !important;
					}

					&.open-menu {
						left: 0;
					}
				}

				@media (min-width: 1024px) {
					padding: 0px 0.5vw;
				}

				&-link {
					color: color(info-black);

					@media (min-width: 1024px) {
						text-decoration: none;
					}

					@media (max-width: 1024px) {
						color: white;
						font-weight: 600;
						text-align: left;
						text-decoration: none;
						padding: 18px 0 18px 60px;
						width: 100%;

						&:nth-child(odd) {
							background: color(odd-primary);
						}
					}
				}

				&-logo {
					@media (max-width: 1024px) {
						text-align: center;
					}
				}
			}
		}

		.link-text-container {
			text-align: right;
			width: 56%;
		}

		.is-active {
			color: color(primary);
			position: relative;

			&::before {
				border-bottom: 3px solid color(primary-cs);
				bottom: -3px;
				content: '';
				left: 0;
				margin-left: auto;
				position: absolute;
				top: 0;
				right: 0;
				width: 80%;
				z-index: 0;
			}

			@media (max-width: 1024px) {
				color: color(white);

				&::before {
					width: 100%;
				}
			}
		}

		.show-image {
			display: inline-block;
		}

		.show-not-image {
			display: none;
		}

		.text-logo {
			font-size: size(small);
			color: color(primary);
			text-transform: none;
		}

		.logo-menu-mobile {
			display: none;
			text-align: left;
			padding: 0 0 17px 60px;

			@media (max-width: 1024px) {
				display: inline-block;
				width: 100%;
			}
		}

		.logo-close {
			display: none;
			padding: 24px 0 0 21px;
			text-align: left;

			@media (max-width: 1024px) {
				display: inline-block;
				width: 100%;
			}
		}

		.li-logo {
			background: none !important;
			padding: 0;
		}

		.app-header-mobile {
			background: color(white);
			box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.22);
			padding: 16px;
			position: fixed !important;
			top: 0;
			width: 100%;

			@media (min-width: 1024px) {
				display: none;
			}
		}

		.btn-orange {
			background: color(primary-cs);
			border-radius: 8px;
			color: color(white);
			padding: 6px 10px;
			text-decoration: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/app-header.vue